import { messages } from "../../../src/resources/strings";
import { introspectionAPI } from "../user";

export interface ErrorHandler {
  case: 400 | 401 | 403 | 500;
  onError: () => void;
}

export const handleApiError = async (
  error: any,
  errorHandlers?: ErrorHandler[],
  shouldCheckIntrospection: boolean = true
) => {
  // Generic error handler for any error without response property
  if (!error.response) {
    return {
      errorCode: messages.error.trycatchError,
      message: error.message || "Something went wrong",
    };
  }

  if (error === messages.error.networkError) {
    return {
      errorCode: messages.error.networkError,
      message: "Network error occurred",
    };
  }

  const status = error.response.status;

  // Check for custom error handlers first
  if (errorHandlers) {
    for (const handler of errorHandlers) {
      if (handler.case === status) {
        return handler.onError();
      }
    }
  }

  switch (status) {
    case 400:
      console.log("Bad Request Error:", error.response.data);
      return {
        errorCode: messages.error.badRequest,
        message: error?.response?.data?.message || "Invalid request data",
      };
    case 401:
      return {
        errorCode: messages.error.noHarmonyUserFound,
        message: "Unauthorized access",
      };
    case 403:
      if (shouldCheckIntrospection) {
        const introspectionResponse = await introspectionAPI();
        if (!introspectionResponse.response) {
          return {
            errorCode: messages.error.resetPasswordLogout,
            message: "Session expired",
          };
        }
      }
      return {
        errorCode: messages.error.noPolicyFound,
        message: "Access forbidden",
      };
    case 404:
      return {
        errorCode: messages.error.noData,
        message: "Resource not found",
      };

    case 500:
      return {
        errorCode: messages.error.noData,
        message: "Internal Server Error",
      };
      
    default:
      return {
        errorCode: messages.error.trycatchError,
        message: "An unexpected error occurred",
      };
  }
};
